// extracted by mini-css-extract-plugin
export default {"button28":"MyButton_button28__2alRH"};